import * as React from "react";
const SvgFiRrUmbrellaBeach = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-umbrella-beach_svg__a)">
      <path
        fill="#062147"
        d="M23 22c-.415 0-.92-.207-1.455-.426-.658-.27-1.404-.574-2.212-.574s-1.554.305-2.212.574c-.535.219-1.041.426-1.455.426s-.92-.207-1.455-.426c-.658-.27-1.404-.574-2.212-.574s-1.554.305-2.212.574c-.388.159-.76.31-1.093.383l3.752-8.471 7.186 3.276a2.93 2.93 0 0 0 2.578-.063 2.97 2.97 0 0 0 1.56-2.083c1.108-5.695-1.6-11.261-6.587-13.535C12.049-1.26 5.913.356 2.592 4.926a3.1 3.1 0 0 0-.489 2.618 3 3 0 0 0 1.658 1.982l6.865 3.13-3.919 8.849C6.092 21.255 5.405 21 4.666 21c-.808 0-1.554.305-2.212.574-.535.219-1.04.426-1.455.426a1 1 0 0 0 0 2c.808 0 1.554-.305 2.212-.574.535-.22 1.04-.426 1.455-.426s.92.207 1.455.426c.658.269 1.404.574 2.212.574s1.554-.305 2.212-.574C11.08 23.206 11.585 23 12 23s.92.207 1.455.426c.658.269 1.404.574 2.212.574s1.554-.305 2.212-.574c.535-.22 1.041-.426 1.455-.426s.92.207 1.455.426c.658.269 1.404.574 2.212.574A1 1 0 1 0 23 22M4.037 7.034A1.1 1.1 0 0 1 4.21 6.1C6.929 2.36 12.15.983 16.354 2.9c4.142 1.889 6.385 6.549 5.454 11.333a.97.97 0 0 1-.512.686.94.94 0 0 1-.833.022L4.591 7.707a1 1 0 0 1-.554-.673"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-umbrella-beach_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUmbrellaBeach;
